import { useState, useEffect, useRef } from 'react';
import { Box, Typography, Button, Toolbar } from '@mui/material';
import { useSelectedRows } from '../componentes/tabla/SelectedRowsContext';
import BtnEliminar from "../componentes/botones/Delete"
import BtnGenContestacion from "../componentes/botones/GeneraContestacion"
import BtnEnviarContestacion from "../componentes/botones/EnviarContestacion"
import BtnAgregar from '../componentes/botones/Agregar';
import BtnUnificar from '../componentes/botones/Unificar';
import BtnInforme from '../componentes/botones/DescargarInforme';
import ProgressBarModal from '../componentes/modales/ProgressBar';
import '../estilo/App.css';
import axiosInstancePromise from '../general/axiosConfig';
import {styleBoxLeft} from '../estilo/Main'

const LeftContestaciones = ({ signalTable }) => {
  const { selectedRows, setSelectedRows} = useSelectedRows();
  const [ tablaActual, setTablaActual ] = useState('');
  const [vistaActual, setVistaActual] = useState(localStorage.getItem('view') || '');
  const [openModalBar, setOpenModalBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [message, setMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const checkInterval = useRef(null);

  useEffect(() => {
    setVistaActual(localStorage.getItem('view'));
  }, [vistaActual]);

  useEffect(() => {
    setTablaActual(localStorage.getItem('view'));
  }, [tablaActual]);

  const handleProcesar = async () => {
    setMessage('Procesando documentos seleccionados...');
    setOpenModalBar(true);

    try {
      const nombre_archivos = selectedRows
        .map(row => row['Nombre_archivo'])
        .filter(Boolean);

      if (nombre_archivos.length === 0) {
        alert("No hay archivos válidos para procesar.");
        setOpenModalBar(false);
        return;
      }

      const axiosInstance = await axiosInstancePromise;

      const response = await axiosInstance.post(`/procesar-pdf`, { rows: selectedRows }, {
        headers: { 'Content-Type': 'application/json' },
        validateStatus: status => status === 202 || (status >= 200 && status < 300),
      });

      // Aseguramos que task_id sea tratado como array, aunque venga como string
      const rawJobIds = response.data.job_ids;
      const taskIds = Array.isArray(rawJobIds)
        ? rawJobIds
        : String(rawJobIds).split(',').map(id => id.trim()).filter(Boolean);

      if (taskIds.length === 0) {
        throw new Error("No se recibieron identificadores de tarea para seguimiento.");
      }

      checkInterval.current = setInterval(async () => {
        try {
          const statusRes = await axiosInstance.post('/task-status', {
            task_id: taskIds,
          });

          const statusMap = statusRes.data;
          const allDone = taskIds.every(id => {
            const state = statusMap[id]?.status;
            return state === 'SUCCESS' || state === 'FAILURE';
          });

          if (allDone) {
            clearInterval(checkInterval.current);
            setOpenModalBar(false);

            const anyFailures = taskIds.some(id => statusMap[id]?.status === 'FAILURE');

            if (anyFailures) {
              setSnackbarMessage(`Uno o más archivos NO han sido procesados correctamente.`);
              setSnackbarSeverity('error');
            } else {
              setSnackbarMessage(`Los archivos ${nombre_archivos.join(", ")} han sido procesados con éxito.`);
              setSnackbarSeverity('success');
            }

            signalTable();
          }
        } catch (statusErr) {
          console.error("Error al verificar estado de procesamiento:", statusErr);
          clearInterval(checkInterval.current);
          setOpenModalBar(false);
          setSnackbarMessage("Error al verificar el estado del procesamiento.");
          setSnackbarSeverity("error");
        }
      }, 5000);

    } catch (error) {
      console.error('Error al procesar los documentos:', error);
      clearInterval(checkInterval.current);
      setOpenModalBar(false);
      setSnackbarMessage("Error en el envío de archivos al procesador.");
      setSnackbarSeverity('error');
    }
    setSelectedRows([]);
  };

  const funcSignal = async () => {
    signalTable();
  };

  return (
    <Box sx={styleBoxLeft}>
      <Toolbar />
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>ACCIONES</Typography>
      {(localStorage.getItem('view') === 'procesador') &&
      <>
        <Button sx={{mt:2}} variant="outlined" disabled={selectedRows.length === 0 || localStorage.getItem('tact') === 'DocsSubidosProcesados'}
         onClick={handleProcesar}
        >Procesar</Button>
        <BtnEliminar table={'DocumentosSubidos'} funcSenal={funcSignal}/>
      </>
      }
      {(localStorage.getItem('view') !== 'procesador' && 
        localStorage.getItem('view') !== 'FacturasRd' &&
        localStorage.getItem('view') !== 'soportes' &&
        localStorage.getItem('view') !== 'Contestaciones' &&
        localStorage.getItem('view') !== 'informes') &&
        <BtnAgregar table={tablaActual} funcSenal={signalTable}/>
      }
      {(localStorage.getItem('view') === 'informes') &&
        <BtnInforme/>
      }
      {( localStorage.getItem('view') === 'soportes') &&
        <BtnUnificar />
      }
      {(localStorage.getItem('view') === 'FacturasRd') && 
        <BtnGenContestacion table={'DocumentosSubidos'} funcSenal={funcSignal}/>
      }
      {( localStorage.getItem('view') === 'Contestaciones') &&
        <BtnEnviarContestacion table={'Contestaciones'} funcSenal={funcSignal}/>
      }
      {(localStorage.getItem('view') === 'DiccionarioClientes') &&
        <BtnEliminar table={'DiccionarioClientes'} funcSenal={funcSignal}/>
      }
      {(localStorage.getItem('view') === 'DiccionarioCodigoGen') &&
        <BtnEliminar table={'DiccionarioCodigoEsp'} funcSenal={funcSignal}/>
      }
      {(localStorage.getItem('view') === 'DiccionarioCodigoEsp') &&
        <BtnEliminar table={'DiccionarioCodigoEsp'} funcSenal={funcSignal}/>
      }
      <ProgressBarModal open={openModalBar} duration={(selectedRows.length * 1000) + 3000}
        progreso={0}
        message={message}
        snackbarMessage={snackbarMessage} 
        severity={snackbarSeverity}
        onClose={() => setOpenModalBar(false)}/>
    </Box>
  );
};

export default LeftContestaciones;
